import { StaffApi } from 'helpers';

class DomainService {
  authToken: string;
  domainService: StaffApi;

  public constructor(authToken: string) {
    this.authToken = authToken;
    this.domainService = new StaffApi('domain', authToken);
  }
}

export default DomainService;
